import { apiRequest, API_BASE_URL } from '../config/api';

/**
 * Wallet Service
 * Handles all credit and wallet-related API calls
 */

class WalletService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  /**
   * Get current user's wallet info
   */
  async getUserWallet() {
    try {
      const response = await apiRequest('/api/wallet/', {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Error fetching wallet:', error);
      throw error;
    }
  }

  /**
   * Get specific user's wallet info (Admin only)
   */
  async getUserWalletAdmin(userId) {
    try {
      const response = await apiRequest(`/api/wallet/admin/${userId}/`, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Error fetching user wallet:', error);
      throw error;
    }
  }

  /**
   * Adjust user credit (Admin only)
   * positive amount = add, negative amount = deduct
   */
  async adjustCredit(userId, amount, description) {
    try {
      const response = await apiRequest(`/api/wallet/admin/adjust/${userId}/`, {
        method: 'POST',
        body: JSON.stringify({
          amount: parseFloat(amount),
          description: description,
        }),
      });
      return response;
    } catch (error) {
      console.error('Error adjusting credit:', error);
      throw error;
    }
  }

  /**
   * Get all user wallets (Admin only)
   */
  async getAllWallets() {
    try {
      const response = await apiRequest('/api/wallet/admin/all/', {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Error fetching all wallets:', error);
      throw error;
    }
  }

  /**
   * Get all wallet transactions (Admin only)
   */
  async getAllTransactions() {
    try {
      const response = await apiRequest('/api/wallet/admin/transactions/', {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Error fetching all transactions:', error);
      throw error;
    }
  }
}

// Create and export singleton instance
const walletService = new WalletService();
export default walletService;
